import { render, staticRenderFns } from "./Jlzx.vue?vue&type=template&id=34265ccf&scoped=true&"
import script from "./Jlzx.vue?vue&type=script&lang=js&"
export * from "./Jlzx.vue?vue&type=script&lang=js&"
import style0 from "./Jlzx.vue?vue&type=style&index=0&id=34265ccf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34265ccf",
  null
  
)

export default component.exports